import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Code Sandbox property - Definition */
export class DocsBlockCodeSandboxPropertyDefinition extends DocsBlockPropertyDefinition {
}
